import Vue from 'vue'
import Vuex from 'vuex'
import {
	isStringBlank
} from '@/utils'
import {
	login,
	logout
} from '@/api/user'
import {
	getAllTypes
} from '@/api/goods.js'
import {
	getToken,
	setToken,
	removeToken,
	getUserInfo,
	setUserInfo,
	removeUserInfo
} from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		hasLogin: !isStringBlank(getUserInfo()),
		token: getToken(),
		userInfo: !isStringBlank(getUserInfo()) ? JSON.parse(getUserInfo()) : {},
		vuex_searchKey: '',
		vuex_cartList: [],
		vuex_myCenterSelectedMenu: 'wddd'
	},
	getters: {
		hasLogin: state => state.hasLogin,
		token: state => state.token,
		userInfo: state => state.userInfo,
		vuex_searchKey: state => state.vuex_searchKey,
		vuex_cartList: state => state.vuex_cartList,
		vuex_myCenterSelectedMenu: state => state.vuex_myCenterSelectedMenu
	},
	mutations: {
		SET_HASLOGIN: (state, hasLogin) => {
			state.hasLogin = hasLogin
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_USERINFO: (state, userInfo) => {
			state.userInfo = userInfo
		},
		SET_SEARCHKEY: (state, vuex_searchKey) => {
			state.vuex_searchKey = vuex_searchKey
		},
		SET_CARTLIST: (state, vuex_cartList) => {
			state.vuex_cartList = vuex_cartList
		},
		SET_MYCENTERSELECTEDMENU: (state, vuex_myCenterSelectedMenu) => {
			state.vuex_myCenterSelectedMenu = vuex_myCenterSelectedMenu
		}
	},
	actions: {
		// user login
		login({
			commit
		}, userInfo) {
			return new Promise((resolve, reject) => {
				login(userInfo).then(async response => {
					if (response && response.code == 0) {
						let userInfo = {
							username: response.data.enterpriseNo,
							token: response.data.token,
							nickname: response.data.enterpriseName,
							enterpriseType: response.data.enterpriseType
						};
						
						commit('SET_USERINFO', userInfo)
						setUserInfo(userInfo)
						commit('SET_TOKEN', response.data.token)
						setToken(response.data.token)
						
						// 获取商品分类
						let res = await getAllTypes();
						
						if (res && res.data) {
							window.sessionStorage.setItem('productTypes', JSON
								.stringify(res.data));
						}
						
						commit('SET_HASLOGIN', true)
					}
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// user logout
		logout({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				logout().then(res => {
					removeToken() // must remove  token  first
					commit('SET_TOKEN', getToken())
					removeUserInfo()
					commit('SET_USERINFO', {})
					window.sessionStorage.clear()
					window.localStorage.clear()
					commit('SET_HASLOGIN', false)
					resolve()
				});
			})
		}
	}
})

export default store